import { REDUCER } from '../reducers/reducersConst';

/**
 * MESSAGE SERVICE REDUCER
 */
let defaultMessagesState = {
  info: [],
  error: [],
  success: [],
  warning: []
};

export let messageAlert = (state = defaultMessagesState, action) => {
  switch (action.type) {
    case REDUCER.MESSAGE.SET_INFO_MESSAGES:
      return {
        ...state,
        info: action.messages
      };
    case REDUCER.MESSAGE.SET_ERROR_MESSAGES:
      return {
        ...state,
        error: action.messages
      };
    case REDUCER.MESSAGE.SET_SUCCESS_MESSAGES:
      return {
        ...state,
        success: action.messages
      };
    case REDUCER.MESSAGE.SET_WARNING_MESSAGES:
      return {
        ...state,
        warning: action.messages
      };
    default:
      return state;
  }
};
